import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F1120lSchLService {

  constructor(private http: HttpClient) { }

  /**
   * Save F1120L Schedule L form data - based on F1120L-SCH-F pattern
   * @param baseUrl Base URL from GENERAL_CONFIG
   * @param mainData Array of form data to save
   * @param globalService Global service object with globalParams
   * @param filterParams Filter parameters from workspace
   * @param rowData Row data from grid
   * @returns Observable with save response
   */
  saveSchddForm(
    baseUrl: string, 
    mainData: any[], 
    globalService: any, 
    filterParams: any = {}, 
    rowData: any = {}
  ): Observable<any> {
    // Build payload EXACTLY like F1120L-SCH-F with proper fallbacks
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Essential parameters with fallbacks
    params.jsonSettings = JSON.stringify({
      "tax_year": rowData.TAX_YEAR,
      "scenario": rowData.SCENARIO,
      "jcd_key": rowData.JCD_KEY,
      "combination_key": rowData.COMBINATION_KEY,
      "trans_type_key": mainData[0].editrows[0][0].trans_type_key
    });
    params.jsonObj = JSON.stringify(mainData);
    params.tax_year = filterParams.tax_year || params.tax_year || rowData.TAX_YEAR;
    params.scenario = filterParams.scenario || params.scenario || rowData.SCENARIO;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || rowData.JCD_KEY || 250;
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";
    params.process_name = filterParams.process_name || "1120L Sch L";
    params.combination_key = rowData.COMBINATION_KEY;
    params.lineAttrKey = mainData[0].editrows[0][0].line_attrib_key;
    
    // Include checkLockedbj from rowData
    const checkLockedbj = [{
      "leid": rowData.LEID,
      "me_code": rowData.ME,
      "combination_key": rowData.COMBINATION_KEY
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    console.log('Save params being sent:', params);

    // MUST use application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = `${baseUrl}/saveJsonObject?action_code=nkepph`;
    
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  // Legacy alias from Gridsave mapping (Form1120LScheduleLFactory.saveF1120LScheduleLDetails)
  saveF1120LScheduleLDetails(
    baseUrl: string,
    mainData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    return this.saveSchddForm(baseUrl, mainData, globalService, filterParams, rowData);
  }
}
